import setTopBar from '../components/topBar';
const Login = {

  init: function () {
    setTopBar();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Login.init()
})



// Função para validar a força da senha
function validarForcaSenha(senha) {
    // Pelo menos 6 caracteres
    if (senha.length < 6) {
        return { valida: false, motivo: 'A senha deve ter pelo menos 6 caracteres' };
    }
    
    // Pelo menos uma letra maiúscula
    if (!/[A-Z]/.test(senha)) {
        return { valida: false, motivo: 'A senha deve conter pelo menos uma letra maiúscula' };
    }
    
    // Pelo menos uma letra minúscula
    if (!/[a-z]/.test(senha)) {
        return { valida: false, motivo: 'A senha deve conter pelo menos uma letra minúscula' };
    }
    
    // Pelo menos um caractere especial
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(senha)) {
        return { valida: false, motivo: 'A senha deve conter pelo menos um caractere especial' };
    }
    
    return { valida: true, motivo: '' };
}

// Função para verificar se os campos são iguais e validar a senha
function verificarCampos() {
    const campoPassword = document.querySelector('input[name="password"]');
    const campoPasswordConfirmation = document.querySelector('input[name="passwordConfirmation"]');
    const botao = document.querySelector('button.cmp-buyer-login-button');
    
    // Se algum elemento não existir, retorna
    if (!campoPassword || !campoPasswordConfirmation || !botao) {
        return;
    }
    
    const senha = campoPassword.value;
    const confirmacao = campoPasswordConfirmation.value;
    
    // Verifica se ambos os campos têm conteúdo, são iguais E a senha é forte
    const validacaoSenha = validarForcaSenha(senha);
    const camposIguais = senha && confirmacao && senha === confirmacao;
    
    if (camposIguais && validacaoSenha.valida) {
        botao.disabled = false;
        limparMensagemErro();
    } else {
        botao.disabled = true;
        
        // Mostra mensagem de erro apropriada
        if (senha && !validacaoSenha.valida) {
            mostrarMensagemErro(validacaoSenha.motivo);
        } else if (senha && confirmacao && senha !== confirmacao) {
            mostrarMensagemErro('As senhas não coincidem');
        } else {
            limparMensagemErro();
        }
    }
}

// Função para mostrar mensagem de erro
function mostrarMensagemErro(mensagem) {
    // Remove mensagem anterior se existir
    limparMensagemErro();
    
    const campoPassword = document.querySelector('input[name="password"]');
    if (!campoPassword) return;
    
    // Cria elemento de mensagem de erro
    const mensagemErro = document.createElement('div');
    mensagemErro.id = 'senha-erro-mensagem';
    mensagemErro.style.color = '#d32f2f';
    mensagemErro.style.fontSize = '12px';
    mensagemErro.style.marginTop = '5px';
    mensagemErro.style.padding = '5px';
    mensagemErro.style.backgroundColor = '#ffebee';
    mensagemErro.style.borderRadius = '4px';
    mensagemErro.style.border = '1px solid #f44336';
    mensagemErro.textContent = mensagem;
    
    // Insere após o campo de senha
    campoPassword.parentNode.insertBefore(mensagemErro, campoPassword.nextSibling);
    
    // Adiciona estilo de erro no campo
    campoPassword.style.borderColor = '#f44336';
    const campoConfirmacao = document.querySelector('input[name="passwordConfirmation"]');
    if (campoConfirmacao) {
        campoConfirmacao.style.borderColor = '#f44336';
    }
}

// Função para limpar mensagem de erro
function limparMensagemErro() {
    const mensagemExistente = document.getElementById('senha-erro-mensagem');
    if (mensagemExistente) {
        mensagemExistente.remove();
    }
    
    // Restaura cor original dos campos
    const campoPassword = document.querySelector('input[name="password"]');
    const campoConfirmacao = document.querySelector('input[name="passwordConfirmation"]');
    
    if (campoPassword) {
        campoPassword.style.borderColor = '';
    }
    if (campoConfirmacao) {
        campoConfirmacao.style.borderColor = '';
    }
}

// Função para mostrar requisitos da senha (opcional)
function mostrarRequisitosSenha() {
    const campoPassword = document.querySelector('input[name="password"]');
    if (!campoPassword || document.getElementById('requisitos-senha')) return;
}

// Observa mudanças em tempo real nos campos
function iniciarObservacao() {
    const campoPassword = document.querySelector('input[name="password"]');
    const campoPasswordConfirmation = document.querySelector('input[name="passwordConfirmation"]');
    
    if (campoPassword && campoPasswordConfirmation) {
        // Adiciona event listeners para vários tipos de eventos
        const eventos = ['input', 'change', 'keyup', 'paste'];
        
        eventos.forEach(evento => {
            campoPassword.addEventListener(evento, verificarCampos);
            campoPasswordConfirmation.addEventListener(evento, verificarCampos);
        });
        
        // Mostra requisitos da senha
        mostrarRequisitosSenha();
        
        // Verifica o estado inicial
        verificarCampos();
    } else {
        // Se os campos não existirem ainda, tenta novamente após um tempo
        setTimeout(iniciarObservacao, 500);
    }
}

// Inicia a observação quando o DOM estiver carregado
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarObservacao);
} else {
    iniciarObservacao();
}